const HisFolderSearch = ({ color, sx }) => {
  const strokeColor = color ?? "#708FBB";
  const _sx = sx ?? {};
  return (
    <svg
      style={_sx}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4126 18.5245H3.99593C3.5097 18.5245 3.04339 18.3313 2.69957 17.9875C2.35575 17.6437 2.1626 17.1774 2.1626 16.6912V4.7745C2.1626 3.76616 2.9876 2.94116 3.99593 2.94116H7.59843C7.90039 2.94272 8.1973 3.01885 8.46276 3.16277C8.72822 3.3067 8.95402 3.51397 9.1201 3.76616L9.87176 4.86616C10.0378 5.11836 10.2636 5.32562 10.5291 5.46955C10.7946 5.61347 11.0915 5.6896 11.3934 5.69116H18.6626C19.1488 5.69116 19.6151 5.88432 19.959 6.22813C20.3028 6.57195 20.4959 7.03827 20.4959 7.5245V11.1912"
        stroke={strokeColor}
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9126 18.5244C17.4314 18.5244 18.6626 17.2932 18.6626 15.7744C18.6626 14.2556 17.4314 13.0244 15.9126 13.0244C14.3938 13.0244 13.1626 14.2556 13.1626 15.7744C13.1626 17.2932 14.3938 18.5244 15.9126 18.5244Z"
        stroke={strokeColor}
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5796 19.4412L18.2046 18.0662"
        stroke={strokeColor}
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisFolderSearch;
